import styled, { css } from "styled-components"

export const Container = styled.div`
    input{
        color: gray;
        width: 100%;
        font-size: 1rem;
        border: none;
        padding: 1rem;
        border-radius: 10px;

        @media (max-height: 670px){
            height: 40px;
         
        }
    }  

    border-radius: 10px;
    border: 1px solid ${props => props.isFocused ? 'var(--colorBgHeader)' : '#D3D3D3'};
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgb(0 0 0 / 8%), 0 8px 16px rgb(0 0 0 / 8%);

    img{
        height: 25px;
        margin: 0 1rem;
    }

    ${props => props.fullInput && css`
        display: flex;
        align-items: center;

        input{
            flex: auto;
        }
    `}

    ${props => props.empty && css`
        border-color: red;
    `}

   
`